import { LiveReplay } from '~/types';
import isReplayReady from '~/helpers/isReplayReady';

export default function getStreamIdToPlay({
  liveSaleIdFromStreamInfo,
  selectedStreamId,
  isInfluencerLive,
  mostRecentReplay,
  nextLive,
}: {
  liveSaleIdFromStreamInfo?: number;
  selectedStreamId?: number;
  isInfluencerLive: boolean;
  mostRecentReplay?: LiveReplay;
  nextLive: string | null;
}) {
  if (isInfluencerLive) return liveSaleIdFromStreamInfo;

  if (selectedStreamId) return selectedStreamId;
  if (
    !mostRecentReplay ||
    !isReplayReady(mostRecentReplay) ||
    !mostRecentReplay.ended_at
  ) {
    return;
  }
  if (!nextLive) return mostRecentReplay.id;

  const shouldShowRecentReplay = getShouldShowRecentReplay(
    new Date(nextLive).getTime(),
    mostRecentReplay.ended_at * 1000, // Seconds to milliseconds
  );

  return shouldShowRecentReplay ? mostRecentReplay.id : undefined;
}

function getShouldShowRecentReplay(
  scheduledLiveTime: number,
  latestReplayTime: number,
) {
  const now = Date.now();
  const twoHours = 7200000;

  const scheduleLiveIs2HoursOut = scheduledLiveTime - now > twoHours;
  const scheduleLiveHasHappened = latestReplayTime >= scheduledLiveTime;

  return scheduleLiveIs2HoursOut || scheduleLiveHasHappened;
}
